import { Component, input, OnInit } from "@angular/core";
import { Router, RouterLink } from "@angular/router";


import {
  SessionData,
  SessionService,
} from "../../Utils/_services/session/session.service";
import { environment } from "../../environments/environment";


@Component({
  selector: "app-nav-bar",
  standalone: true,
  imports: [RouterLink],
  templateUrl: "./nav-bar.component.html",
  styleUrls: ["./nav-bar.component.css"],
})
export class NavBarComponent implements OnInit {
   pwaUrl: string = `${environment.pwaFrontendBaseUrl}/auth/signup`;
   private insizonFrontendBaseUrl = environment.insizonFrontendBaseUrl;

   get getFeatureLink() {
     return `${this.insizonFrontendBaseUrl}/`;
   }

   get getContactUsLink() {
     return `${this.insizonFrontendBaseUrl}/contact`;
   }

   get getBugRepoLink() {
     return `${this.insizonFrontendBaseUrl}/bug-logs`;
   }
  
  constructor(
    private sessionService: SessionService,
    private router: Router
  ) {}

  showMenu = input(true);
  isMenuOpen = false;
  sessionData!: SessionData | null;

  ngOnInit(): void {
    this.sessionService.sessionData$.subscribe(data => {
      this.sessionData = data;
    });
  }

  goToAdmin() {
    this.router.navigate(["/auth/login"]);
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }

  logout() {
    try {
      this.sessionService.clearSession();
      localStorage.removeItem("user");
    } catch (err) {
      console.warn("Error clearing session on logout", err);
    }
    this.router.navigate(["/auth/login"]);
  }


redirectToDownload() {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  const iOSStoreUrl = "https://apps.apple.com/app/idYOUR_APP_ID";
  const androidStoreUrl = "https://play.google.com/store/apps/details?id=com.poptheballon.insizion";
  const desktopPwaUrl = this.pwaUrl;

  console.log("User Agent:", userAgent);

  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    console.log("Redirecting to App Store");
    window.location.href = iOSStoreUrl;

  } else if (/android/i.test(userAgent)) {
    console.log("Redirecting to Play Store");
    window.location.href = androidStoreUrl;

  } else {
    console.log("Redirecting to Desktop PWA");
    window.location.href = desktopPwaUrl;
  }
}
}
